import React, { useContext } from 'react'
import jwtDecode from 'jwt-decode'
import loginApi from 'api/login'
import { loginSubmission } from 'api/login'
import useSignUpData from 'hooks/useSignUpData'
import get from 'lodash/get'
import { ModalContext } from 'providers/Modal'
import { getGoogleClienIdMapping } from 'utils/parseDomain'
import {
  trackGoogleOneTapShown,
  trackGoogleOneTapNotShown,
  trackGoogleOneTapClicked,
  trackGoogleOneTapClosed,
  trackGoogleOneTapSignUp,
  trackGoogleOneTapLogin,
  trackOnBlur,
} from 'tracking/homepage'

/**
 * This hook initializes GSI client and handles sign up & login into Shaadi Account using Google Id
 */

const useGoogleOneTap = () => {
  const [, , updateData] = useSignUpData()
  const { setActive } = useContext(ModalContext)
  const type = 'google'

  React.useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.defer = true
    script.onload = initializeGSI
    document.querySelector('body').appendChild(script)
  }, [])

  const initializeGSI = () => {
    // @ts-ignore
    google.accounts.id.initialize({
      client_id: getGoogleClienIdMapping(),
      callback: onOneTapSignedIn,
      context: 'signup',
    })

    // Google one tap layer display status
    // @ts-ignore
    google.accounts.id.prompt(notification => {
      // layer displayed
      if (notification.isDisplayed()) {
        trackGoogleOneTapShown()
      } else if (notification.isNotDisplayed()) {
        trackGoogleOneTapNotShown(notification.getNotDisplayedReason())
      } else if (notification.isSkippedMoment()) {
        trackGoogleOneTapClosed(notification.getSkippedReason())
      }
    })
  }

  const onOneTapSignedIn = res => {
    const id_token = res.credential
    const { email, given_name: first_name, family_name: last_name } = jwtDecode(
      res.credential
    )

    updateData({
      data: { email, first_name, last_name },
      type,
      gToken: id_token,
    })

    // Track google account selected
    trackGoogleOneTapClicked({ fieldName: 'google_account', fieldValue: email })

    // Verify user for shaadi account
    verifyUser({ email, id_token })
  }

  const verifyUser = async ({ email, id_token }) => {
    const response = await loginApi({
      username: email,
      password: id_token,
      type,
    })

    // If user already exists
    if (get(response, 'data.uid')) {
      // Track Google Login Success
      trackGoogleOneTapLogin({ fieldName: 'google_login', fieldValue: email })

      // Login to shaadi account
      loginSubmission(email, id_token, type, response)
    }
    // If new user
    else if (
      get(response, 'error.message_shortcode') === 'member_not_found_with_gmail'
    ) {
      // Track Google prefilled email on reg modal
      trackGoogleOneTapSignUp({ fieldName: 'reg_modal', fieldValue: email })
      trackOnBlur({ fieldName: 'email', fieldValue: email })

      // Show reg modal
      setActive('register')
    }
  }
}

export default useGoogleOneTap
